/* EG Collections — Data + selections (tags map, lite products fetch, URL/UI selection parsing, matching) */

function egReadAllTagsMap() {
  const el = document.getElementById("eg-collection-all-tags-map");
  if (!el) return [];
  try {
    const arr = JSON.parse(el.textContent || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
}

function egBuildTagHandleLookup() {
  // Persist across theme section swaps where #eg-collection-all-tags-map may be missing.
  if (window.__egTagHandleLookup instanceof Map && window.__egTagHandleLookup.size) {
    return window.__egTagHandleLookup;
  }

  const mapArr = egReadAllTagsMap();
  const byTag = new Map();

  mapArr.forEach(o => {
    if (o && typeof o.tag === "string" && typeof o.handle === "string") {
      byTag.set(o.tag, o.handle);
    }
  });

  window.__egTagHandleLookup = byTag;
  return byTag;
}

async function egGetFullCollectionProducts(handle) {
  if (!handle) return [];
  const cacheKey = handle; // stable across pages/filters
  const isLatestDrops = handle === "latest-drops";

  // Cache across navigation
  if (window.__egFullCollectionProducts?.key === cacheKey) {
    return window.__egFullCollectionProducts.products;
  }

  const base = `https://gear-db-proxy.onrender.com/collections/${handle}/products-lite`;
  const limit = 250;
  const all = [];
  const seen = new Set();

  for (let page = 1; page <= 200; page++) {
    const url = `${base}?limit=${limit}&page=${page}`;
    const res = await fetch(url, { credentials: "omit", cache: "no-store" });

    if (!res.ok) {
      console.error("EG full collection fetch failed", handle, res.status, "page", page);
      return [];
    }

    const json = await res.json();
    const arr = (json && json.ok && Array.isArray(json.products)) ? json.products : [];

    // stop when the API returns no products for this page
    if (!arr.length) break;

    for (const p of arr) {
      const h = String(p?.handle || "").trim();
      if (!h || seen.has(h)) continue;
      seen.add(h);
      all.push(p);
    }

    // If the API says it returned less than limit, we are done
    if (arr.length < limit) break;
  }

  if (!all.length) {
    console.error("EG full collection fetch returned empty", handle);
    return [];
  }

  if (isLatestDrops) {
    all.sort(function(a, b) {
      var da = Date.parse(a.published_at || a.created_at || 0);
      var db = Date.parse(b.published_at || b.created_at || 0);
      return db - da;
    });

    all.length = Math.min(all.length, 24);
  }

  window.__egFullCollectionProducts = { key: cacheKey, products: all };
  return all;
}

function egGetActiveShopifyFacetSelections(root) {
  // paramName -> Set(values)
  const out = new Map();

  root.querySelectorAll('input[type="checkbox"][data-filter-key]').forEach(input => {
    const name = input.getAttribute("name") || "";
    if (!name.startsWith("filter.")) return;
    if (!input.checked) return;

    const v = String(input.value || "").trim();
    if (!v) return;

    if (!out.has(name)) out.set(name, new Set());
    out.get(name).add(v);
  });

  return out;
}

function egGetActiveEgTagSelections(root) {
  // groupKey -> Set(fullTag strings)
  const out = new Map();

  root.querySelectorAll('input[type="checkbox"][data-eg-kind="tag"]:checked').forEach(input => {
    const groupKey = String(input.dataset.egTagGroup || "");
    const fullTag = String(input.value || "").trim();
    if (!groupKey || !fullTag) return;

    if (!out.has(groupKey)) out.set(groupKey, new Set());
    out.get(groupKey).add(fullTag);
  });

  return out;
}

function egGetPrettyCfg() {
  return window.EG_URL_PRETTY || {};
}

function egBuildReverseMap(obj) {
  var out = {};
  if (!obj) return out;
  for (var k in obj) {
    if (!obj.hasOwnProperty(k)) continue;
    out[String(obj[k])] = String(k);
  }
  return out;
}

function egSpGetAllBoth(sp, longKey, shortKey) {
  var out = [];
  if (!sp) return out;

  // long
  var a = sp.getAll(longKey);
  for (var i = 0; i < a.length; i++) out.push(a[i]);

  // short
  if (shortKey) {
    var b = sp.getAll(shortKey);
    for (var j = 0; j < b.length; j++) out.push(b[j]);
  }

  // trim + de-dupe
  var seen = {};
  var clean = [];
  for (var x = 0; x < out.length; x++) {
    var v = String(out[x] || "").trim();
    if (!v) continue;
    if (seen[v]) continue;
    seen[v] = 1;
    clean.push(v);
  }
  return clean;
}

function egGetActiveShopifyFacetSelectionsFromUrl() {
  // paramName -> Set(values)
  var sp = new URLSearchParams(window.location.search || "");
  var out = new Map();

  var cfg = (typeof egGetPrettyCfg === "function") ? egGetPrettyCfg() : (window.EG_URL_PRETTY || {});
  var facetAliases = (cfg && cfg.facetParamAliases) ? cfg.facetParamAliases : {};

  // Only read facets you can evaluate from lite payload
  // (These must match what your filter UI writes)
  var keys = ["filter.p.vendor", "filter.p.product_type", "filter.v.availability"];

  for (var i = 0; i < keys.length; i++) {
    var longKey = keys[i];
    var shortKey = facetAliases[longKey] || null;

    // Read both long + short forms from the URL
    var vals = (typeof egSpGetAllBoth === "function")
      ? egSpGetAllBoth(sp, longKey, shortKey)
      : sp.getAll(longKey);

    if (!vals || !vals.length) continue;

    out.set(longKey, new Set(vals));
  }

  return out;
}

function egReadActiveEgTagParams() {
  // groupKey -> Set(tagHandle)
  var sp = new URLSearchParams(window.location.search || "");

  var cfg = egGetPrettyCfg();
  var tagAliases = (cfg && cfg.tagParamAliases) ? cfg.tagParamAliases : {};
  var revTag = egBuildReverseMap(tagAliases);
  var useSuffix = !!(cfg && cfg.tagValueUseSuffix);

  // Build handle universe (fullTag -> handle)
  var byTag = (typeof egBuildTagHandleLookup === "function") ? egBuildTagHandleLookup() : null;

  // Invert to: handle -> fullTag
  var handleToFull = new Map();
  if (byTag && byTag.forEach) {
    byTag.forEach(function (handle, fullTag) {
      if (handle && fullTag) handleToFull.set(String(handle), String(fullTag));
    });
  }

  // Helper: normalize a URL value to a handle
  function toHandleForGroup(groupKey, rawVal) {
    var v = String(rawVal || "").trim();
    if (!v) return "";

    // If already looks like a handle with __, keep it (e.g. surface-type__balanced)
    if (v.indexOf("__") !== -1) return v;

    // If suffix mode, user may pass just "balanced" for st=balanced
    if (useSuffix && handleToFull && handleToFull.forEach) {
      var found = "";
      handleToFull.forEach(function (fullTag, h) {
        if (found) return;

        // expected prefix from config tagGroups match.startsWith (preferred),
        // falls back to the older hardcoded ones.
        var expected = "";

        try {
          var root = document.getElementById("eg-collection-filters");
          if (root && typeof getRuleForRoot === "function") {
            var rule = getRuleForRoot(root);
            var tgs = (rule && Array.isArray(rule.tagGroups)) ? rule.tagGroups : [];
            var excludeStarts = [];

            for (var gi = 0; gi < tgs.length; gi++) {
              var gd = tgs[gi];
              if (!gd || String(gd.key || "") !== String(groupKey || "")) continue;
              if (gd.match && gd.match.startsWith) expected = String(gd.match.startsWith);
              if (gd.match && Array.isArray(gd.match.excludeStartsWith)) excludeStarts = gd.match.excludeStartsWith;
              break;
            }
          }
        } catch (eCfg) {}

        // Exclusions for this group (e.g. ignore Colour__...)
        for (var ei = 0; ei < excludeStarts.length; ei++) {
          var ex = String(excludeStarts[ei] || "");
          if (ex && String(fullTag).indexOf(ex) === 0) return;
        }

        if (expected && String(fullTag).indexOf(expected) !== 0) return;

        // handle ends with "__" + suffix  (double-underscore tags)
        if (String(h).slice(-2 - v.length) === "__" + v) found = String(h);

        // handle ends with "_" + suffix   (single-underscore tags like stitched-edges_yes, surface-material_cloth)
        else if (String(h).slice(-1 - v.length) === "_" + v) found = String(h);
      });
      return found || v;
    }

    return v;
  }

  // 1) Read standard eg_tag_* params
  var out = new Map();
  sp.forEach(function (val, key) {
    if (key.indexOf("eg_tag_") !== 0) return;

    var groupKey = String(key.replace("eg_tag_", "") || "").trim();
    if (!groupKey) return;

    var set = out.get(groupKey);
    if (!set) { set = new Set(); out.set(groupKey, set); }

    // supports repeated params too
    var vals = sp.getAll(key);
    for (var i = 0; i < vals.length; i++) {
      var h = toHandleForGroup(groupKey, vals[i]);
      if (h) set.add(h);
    }
  });

  // 2) Read pretty params:
  // - alias keys from tagParamAliases (e.g. st=balanced)
  // - OR direct groupKey keys (e.g. firmness=soft) IF that groupKey exists in config
  sp.forEach(function (val, key) {
    key = String(key || "");

    // Ignore normal eg_tag_ params here (handled above)
    if (key.indexOf("eg_tag_") === 0) return;

    // First: alias -> groupKey
    var groupKey = revTag[key] || "";

    // Second: allow direct groupKey param names, but ONLY if it's a known tag group key
    if (!groupKey) {
      try {
        var root = document.getElementById("eg-collection-filters");
        if (root && typeof getRuleForRoot === "function") {
          var rule = getRuleForRoot(root);
          var tgs = (rule && Array.isArray(rule.tagGroups)) ? rule.tagGroups : [];
          for (var gi = 0; gi < tgs.length; gi++) {
            var gd = tgs[gi];
            if (!gd || !gd.key) continue;
            if (String(gd.key) === key) { groupKey = key; break; }
          }
        }
      } catch (eCfg2) {}
    }

    if (!groupKey) return;

    var set = out.get(groupKey);
    if (!set) { set = new Set(); out.set(groupKey, set); }

    var vals = sp.getAll(key);
    for (var i = 0; i < vals.length; i++) {
      var h = toHandleForGroup(groupKey, vals[i]);
      if (h) set.add(h);
    }
  });


  return out;
}

function egBuildEgTagSelectionsFromUrlAsFullTags() {
  // groupKey -> Set(fullTag strings)
  const byTag = egBuildTagHandleLookup(); // fullTag -> handle
  if (!byTag || !byTag.size) return new Map();

  // invert: handle -> fullTag
  const handleToFull = new Map();
  byTag.forEach((handle, fullTag) => {
    if (handle && fullTag) handleToFull.set(String(handle), String(fullTag));
  });

  const active = egReadActiveEgTagParams(); // groupKey -> Set(tagHandle)
  const out = new Map();

  for (const [groupKey, handleSet] of active.entries()) {
    if (!groupKey || !handleSet || !handleSet.size) continue;

    var fullTags = new Set();
    handleSet.forEach(function (h) {
      var key = String(h || "");

      // 1) direct match
      var ft = handleToFull.get(key);

      // 2) if URL used "surface-type__balanced" but lookup uses "balanced"
      if (!ft && key.indexOf("__") !== -1) {
        var suffix = key.split("__").pop();
        ft = handleToFull.get(String(suffix || ""));
      }

      // 3) if URL used "balanced" but lookup uses "surface-type__balanced"
      //    (try to find any handle that ends with "__" + key)
      if (!ft && key && handleToFull && typeof handleToFull.forEach === "function") {
        var wanted = "__" + key;
        handleToFull.forEach(function (fullTag, handle) {
          if (ft) return;
          if (String(handle).slice(-wanted.length) === wanted) ft = String(fullTag);
        });
      }

      if (ft) fullTags.add(ft);
    });

    if (fullTags.size) out.set(groupKey, fullTags);
  }

  return out;
}

function egParseNumberFromTag(tag, prefix) {
  if (!tag || !prefix) return null;

  var s = String(tag);
  var p = String(prefix);

  // exact prefix match, e.g. "Length_420mm"
  if (s.indexOf(p) === 0) s = s.slice(p.length);
  else {
    // tolerate "Length__420mm" etc by matching "Length" head
    var head = p.replace(/_+$/g, ""); // "Length" from "Length_"
    if (s.indexOf(head) === 0) s = s.slice(head.length);
    else return null;
  }

  // Ignore range-style tags like "9511mm-1200mm" (or en-dash),
  // but ALLOW a leading negative sign for tags like "-42dB".
  if (s.indexOf("–") !== -1) return null;

  if (s.indexOf("-") !== -1) {
    // If the hyphen isn't the first char, it's a range or junk => ignore
    if (s.indexOf("-") !== 0) return null;

    // If there is another hyphen after the leading '-', it's a range => ignore
    if (s.slice(1).indexOf("-") !== -1) return null;
  }

  // Take the FIRST numeric token only (safe for "-42dB", "420mm")
  var m = s.match(/(-?\d+(\.\d+)?)/);
  if (!m) return null;

  var n = parseFloat(m[1]);
  return isNaN(n) ? null : n;
}

function egGetProductNumericTagValue(p, prefix) {
  var tags = (p && Array.isArray(p.tags)) ? p.tags : [];
  for (var i = 0; i < tags.length; i++) {
    var n = egParseNumberFromTag(tags[i], prefix);
    if (n !== null) return n;
  }
  return null;
}

function egParseMinMaxFromRangeValue(v) {
  v = String(v || "").trim();
  if (!v) return null;

  // Handle normal positive ranges like "250-500" WITHOUT treating "-" as negative
  var mPos = v.match(/^\s*(\d+(\.\d+)?)\s*-\s*(\d+(\.\d+)?)\s*$/);
  if (mPos) {
    var aPos = parseFloat(mPos[1]);
    var bPos = parseFloat(mPos[3]);
    if (!isFinite(aPos) || !isFinite(bPos)) return null;
    return { min: Math.min(aPos, bPos), max: Math.max(aPos, bPos) };
  }

  // Fallback: support negative ranges like "-57--12"
  var nums = v.match(/-?\d+(\.\d+)?/g) || [];
  if (nums.length < 2) return null;

  var a = parseFloat(nums[0]);
  var b = parseFloat(nums[1]);
  if (!isFinite(a) || !isFinite(b)) return null;

  return { min: Math.min(a, b), max: Math.max(a, b) };
}

function egReadNumericRangesFromUrl() {
  var cfg = window.EG_NUMERIC_TAG_SLIDERS || {};
  var sp = new URLSearchParams(window.location.search || "");
  var out = [];

  for (var k in cfg) {
    if (!cfg.hasOwnProperty(k)) continue;
    var c = cfg[k];
    if (!c || !c.param || !c.prefix) continue;

    var v = String(sp.get(c.param) || "");
    if (!v) v = String(sp.get(String(k)) || ""); // pretty key: length/width/height/etc
    if (!v) continue;

    var mm = egParseMinMaxFromRangeValue(v);
    if (!mm) continue;

    out.push({ prefix: String(c.prefix), min: mm.min, max: mm.max });
  }

  return out;
}

function egReadPriceRangeFromUrl() {
  var sp = new URLSearchParams(window.location.search || "");
  var cfg = (typeof egGetPrettyCfg === "function") ? egGetPrettyCfg() : (window.EG_URL_PRETTY || {});
  var facetAliases = (cfg && cfg.facetParamAliases) ? cfg.facetParamAliases : {};

  var longMin = "filter.v.price.gte";
  var longMax = "filter.v.price.lte";
  var shortMin = facetAliases[longMin] || "";
  var shortMax = facetAliases[longMax] || "";

  var a = sp.get(longMin) || (shortMin ? sp.get(shortMin) : "") || "";
  var b = sp.get(longMax) || (shortMax ? sp.get(shortMax) : "") || "";

  a = String(a || "").replace(/[^\d.]/g, "");
  b = String(b || "").replace(/[^\d.]/g, "");

  if (!a && !b) return null;

  // Shopify price facets are in minor units (pence/cents). Convert to major (GBP) to match lite price_min floats.
  var min = a ? (parseFloat(a) / 100) : null;
  var max = b ? (parseFloat(b) / 100) : null;

  if (min !== null && !isFinite(min)) min = null;
  if (max !== null && !isFinite(max)) max = null;

  if (min === null && max === null) return null;

  return { min: min, max: max };
}

function egProductMatchesSelections(p, shopifySel, egTagSel) {
  // --- Shopify facets (only what exists in lite payload) ---
  for (const [key, set] of shopifySel.entries()) {
    if (key === "filter.p.vendor") {
      if (!set.has(String(p.vendor || ""))) return false;
      continue;
    }

    if (key === "filter.p.product_type") {
      if (!set.has(String(p.type || ""))) return false;
      continue;
    }

    if (key === "filter.v.availability") {
      // Shopify values are typically "1" (in stock) and "0" (out of stock)
      var wantsIn = set.has("1") || set.has("true");
      var wantsOut = set.has("0") || set.has("false");

      // If both selected (or neither), don't filter by availability
      if ((wantsIn && wantsOut) || (!wantsIn && !wantsOut)) continue;

      var isIn = !!(p && (p.variant_available || p.available));
      if (wantsIn && !isIn) return false;
      if (wantsOut && isIn) return false;

      continue;
    }

  }

  // --- EG tag groups (fullTag strings) ---
  const tags = Array.isArray(p.tags) ? p.tags : [];
  const tagSet = new Set(tags.map(egNormalizeTagKey));

  // Behaviour: AND across groups, OR within a group.
  for (const [, chosenFullTags] of egTagSel.entries()) {
    if (!chosenFullTags || chosenFullTags.size === 0) continue;

    let hit = false;
    for (const ft of chosenFullTags) {
      const k = egNormalizeTagKey(ft);
      if (k && tagSet.has(k)) { hit = true; break; }
    }
    if (!hit) return false;
  }

  // Numeric tag sliders (Length_/Width_/Area_) from URL
  var ranges = egReadNumericRangesFromUrl();
  if (ranges && ranges.length) {
    for (var r = 0; r < ranges.length; r++) {
      var rr = ranges[r];
      var val = egGetProductNumericTagValue(p, rr.prefix);

      // If product lacks that dimension tag, treat as non-match
      if (val === null) return false;

      if (val < rr.min || val > rr.max) return false;
    }
  }

    // Price range (min/max) from URL
  try {
    var pr = egReadPriceRangeFromUrl();
    if (pr) {
      var pmin = parseFloat(p.price_min);
      var pmax = parseFloat(p.price_max || p.price_min);

      if (!isFinite(pmin)) pmin = 0;
      if (!isFinite(pmax)) pmax = pmin;

      // Treat product as matching if its price range intersects the filter range.
      if (pr.min !== null && pmax < pr.min) return false;
      if (pr.max !== null && pmin > pr.max) return false;
    }
  } catch (ePrice) {}

  return true;
}
